export default {
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_LABEL: 'EYE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL: 'POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL: 'DIA',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL: 'BC',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL: 'ADD',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL: 'BOXES',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL: 'AXIS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL: 'CYL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL: 'COLOR',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL: 'DOMINANCE',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LONG_LABEL:
        'OD (Right Eye)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LONG_LABEL:
        'OS (Left Eye)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL: 'OD (right)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL: 'OS (left)',
    ADD_PRESCRIPTION_STEP_1_LEFT: 'OS (Left Eye)',
    CONTACT_LENSES_SHOW_SAVED_PRESCRIPTION: 'Show prescription',
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED:
        'Don’t forget to save this prescription at checkout for future speedier shopping!',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1: 'Insert your prescription values below or',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2: 'to select one of your saved prescriptions.',
    CONTACT_LENSES_PRESCRIPTION_INCLUDE_PRODUCT_IN_PURCHASE_CHECKBOX:
        'Include this product in my purchase',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD: 'Uploaded on',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE: 'Last updated: ',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATED: 'Just updated',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY: 'Today',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY: 'Yesterday',
    SIGN_IN: 'sign in',
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT1:
        "You don't have a prescription saved in your account including this product.",
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT2:
        'Add your prescription below and save it for future purchases.',
    CL_PDP_TITLE: 'Select your prescription',
    CL_PDP_ERROR:
        'Please select your prescription to add contact lenses to cart and un-check box if only one eye is needed.',
    CL_PDP_PRESCRIPTION_NOT_AVAIABLE: 'The prescription you selected is not available',
    YOUR_PRESCRIPTION_TITLE: 'Your prescription',
    YOUR_PRESCRIPTION_SUBTITLE_PT1:
        'We’ll use this information to make sure everything in your order is correct.',
    YOUR_PRESCRIPTION_SUBTITLE_PT2: 'We’ve got you covered.',
    YOUR_DOCTOR_DETAILS: 'Your doctor’ details',
    DOCTOR_NAME: 'Doctor name',
    CLINIC_NAME: 'Clinic name',
    ADDRESS: 'Address',
    SUBMISSION_METHOD: 'Your submission method',
    MY_SAVED_PRESCRIPTION_TITLE_LABEL: 'My saved prescriptions',
    MY_SAVED_PRESCRIPTION_PRESCRIPTION_NAME_LABEL: 'Prescription name',
    SAME_PRESCRIPTION_BOTH_EYES: 'Same prescription for both eyes',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_1: 'Save ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_2: ' when you buy an annual supply of ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_3: ' boxes!',
    ADD_NEW_PRESCRIPTION_DISCOUNT_6_MONTHS_LABEL_2: ' when you buy a 6-months supply of ',
};
